import { FieldsEnum } from 'app/shared/enums';

export const dateFieldsToValidate = [
  FieldsEnum.CarFirstRegistrationDate,
  FieldsEnum.OwnerBirthDate,
  FieldsEnum.Coowners1BirthDate,
  FieldsEnum.Coowners2BirthDate,
  FieldsEnum.AdditionalDrivers1BirthDate,
];
